'server only';
import { HttpError } from '../../helpers-server';
import { PUBLIC_URL } from '@/helpers/constants';

export const fetchPlayerByCookie = async (cookie: string | null = '') => {
  if (!cookie) {
    throw new HttpError(401, 'Unauthorized');
  }
  const response = await fetch(`${PUBLIC_URL}/api/player`, {
    method: 'GET',
    headers: {
      Cookie: cookie ?? '',
    },
  });

  if (!response.ok) {
    throw new HttpError(
      response.status,
      'SoftSwiss: failed to fetch player data'
    );
  }

  const data = await response.json();

  if (!data.id) {
    throw new HttpError(401, 'Unauthorized');
  }

  return data;
};
